module.exports = __webpack_public_path__ + "img/icon-tipo-legislacao2.d4701113.png";